import { FolderItem } from '../types';

/**
 * Helper to get all descendants of a folder
 * @param folderId The folder ID to get descendants for
 * @param allFolders The complete list of folders to search through
 * @returns Array of descendant folder IDs
 */
export const getAllDescendants = (folderId: string, allFolders: FolderItem[]): string[] => {
  const descendants: string[] = [];
  
  const collectDescendants = (items: FolderItem[]) => {
    for (const item of items) {
      if (item.id === folderId) {
        const collectFromChildren = (children?: FolderItem[]) => {
          if (!children) return;
          children.forEach(child => {
            descendants.push(child.id);
            if (child.children) {
              collectFromChildren(child.children);
            }
          });
        };
        collectFromChildren(item.children);
        return;
      }
      if (item.children) {
        collectDescendants(item.children);
      }
    }
  };
  
  collectDescendants(allFolders);
  return descendants;
};

/**
 * Helper to find entity type (folder or item) by recursively searching
 * @param id The entity ID to find
 * @param foldersToSearch The folders to search through
 * @returns The entity type ('folder' or 'item') or null if not found
 */
export const getEntityType = (id: string, foldersToSearch: FolderItem[]): 'folder' | 'item' | null => {
  for (const folder of foldersToSearch) {
    if (folder.id === id) {
      return folder.type === 'item' ? 'item' : 'folder';
    }
    if (folder.children) {
      const result = getEntityType(id, folder.children);
      if (result) return result;
    }
  }
  return null;
};
